import { Center, Card, Flex, Image, useMantineTheme, Text } from "@mantine/core";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
export function AuthCallback() {
    let params = useParams();
    useEffect(()=>{
        const id = params.consentId;
        // resume AI here
    },[]);
    return (
        
        <Center h="100vh" w="100%">
            <Text>auth callback</Text>
        </Center>
    );
}